module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <div id=\"builder\"></div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiFilter/ubiFilter.html
// module id = ../../../../../src/app/theme/components/ubiFilter/ubiFilter.html
// module chunks = main